



























import moment from 'moment';
import { EvtEvent, EvtType } from 'gl-ms-events';
import Accordion from '@/components/common/accordion.vue';

export default {
    data() {
        return {
        };
    },
    props: ['events'],
    computed: {
        title(this: any) {
            let completed = '';
            if ((this.events[0].event_type as EvtType).name === 'TST') {
                completed = 'Started';
            } else {
                completed = this.event.isExpected ? 'Da completare' : 'Completato';
            }


            return `${this.event.event_type.description} "${completed}"`;
        },
        business(this: any) {
            return this.event.address.ragione_sociale;
        },
        address(this: any) {
            return `${this.event.address.cap}, ${this.event.address.indirizzo}, ${this.event.address.localita}, ${this.event.address.provincia}, (${this.event.address.nazione})`;
        },
        event(this: any) {
            return this.events[0];
        },
        tableData(this: any) {
            return this.events.map((item: EvtEvent) => ({
                name: (item.event_type as EvtType).description,
                value: `Previsto ${moment(item.expected_datetime).format('DD/MM/YYYY HH:mm')}<br>Attule ${item.isExpected ? 'N/A' : moment(item.datetime).format('DD/MM/YYYY HH:mm')}`,
            }));
        },
    },
    components: {
        Accordion,
    },
    methods: {},
    mounted(this: any) {
    },
};
